export default "__VITE_ASSET__BKSqSWrb__"